export default {
	apiKey: "AIzaSyAWZTIlWQOdpaAnj1gy4nUUEtAPHfC9Bps",
	authDomain: "ayun-quantity-dev.firebaseapp.com",
	projectId: "ayun-quantity-dev",
	storageBucket: "ayun-quantity-dev.appspot.com",
	messagingSenderId: "60047801279",
	appId: "1:60047801279:web:658c4c0ff05ddbc934bf0a",
	measurementId: "G-LKKXDGLD84"
};